<script>
  import BenefitItem from './Item.svelte';

  export let image;
  export let icon;
  export let title;
  export let items;
</script>

<section class="benefits-wrap section-border-top">
  <div class="container container--large">
    <div class="benefits">
      <div class="benefits__image">
        {#if image}
          <img src={image.src} alt={image.alt} loading="lazy" />
        {/if}
      </div>
      <div class="benefits__content">
        {#if icon}
          <img
            class="benefits__icon"
            width="67"
            height="80"
            src={icon.src}
            alt={icon.alt}
            loading="lazy"
          />
        {/if}
        <h2 class="h4 benefits__title">{@html title}</h2>

        <div class="benefits__items flexbox flexbox--grid">
          {#each items as item}
            <div class="col col-25 col-s-50">
              <BenefitItem {...item} />
              <div class="line-vertical" />
            </div>
          {/each}
        </div>
      </div>
    </div>
  </div>
</section>

<style lang="scss">
  .benefits {
    @include resp-max('m') {
      position: relative;
      border-radius: 2rem 0;
      overflow: hidden;
    }

    &__image {
      position: absolute;
      z-index: -1;
      inset: 0;

      &::before,
      &::after {
        content: '';
        position: absolute;
        inset: 0;
      }

      &::before {
        @include gradient('grey', 'to top');
      }

      &::after {
        z-index: 1;
        background: url(img/noise.png) 300px 300px;
      }

      img {
        width: 100%;
        height: 100%;
        object-fit: cover;
        object-position: 0 50%;
      }
    }

    &__content {
      @include resp-max('m') {
        color: rgb(var(--white));
        padding: 19rem 0 6rem;
        text-align: center;
      }

      @include resp-max('s') {
        padding: 5rem 0;
      }
    }

    &__image,
    &__icon,
    &__title {
      @include resp-min('m') {
        display: none;
      }
    }

    &__icon {
      width: auto;
      height: 8rem;
      margin: 0 auto;
    }

    &__title {
      margin: 2rem 0 0;
    }

    &__items {
      @include resp-max('m') {
        margin: 6rem 0 0;
      }
    }

    .col {
      position: relative;

      .line-vertical {
        @include resp-max('m') {
          display: none;
        }

        position: absolute;
        top: 0;
        right: 0;
        bottom: 0;
      }

      &:last-child {
        .line-vertical {
          display: none;
        }
      }

      &:nth-child(4) {
        .line-vertical {
          display: none;
        }
      }
    }
  }
</style>
